<template>
    <q-page padding>
        <div class="row q-mb-sm">
            <div class="col-xs-12 col-sm-12">
                <div class="q-display-1 text-secondary">
                    <q-icon name="fas fa-podcast" class="q-mb-sm" /> {{ $t(title_podcasts) }}
                </div>
            </div>
        </div>

        <q-tabs v-model="tab">
            <q-tab slot="title" name="basic-data" :label="$t('basic_data')" />
            <q-tab slot="title" name="audios" :label="$t('audios')" v-show="showTab" />
            <q-tab slot="title" name="configure_and_publish" :label="$t('configure_and_publish')" v-show="showTab" />
            <q-tab slot="title" v-if="useCommentsPodcast" name="comments" :label="$t('comments')" v-show="showTab" />

            <q-tab-pane name="basic-data">
                <basic-data :managePodcasts="permissions.podcasts_manage" />
            </q-tab-pane>

            <q-tab-pane name="audios">
                <audios :managePodcasts="permissions.podcasts_manage" />
            </q-tab-pane>

            <q-tab-pane name="configure_and_publish">
                <configure-and-publish @duplicate="changeTab" :managePodcasts="permissions.podcasts_manage" />
            </q-tab-pane>

            <q-tab-pane name="comments">
                <comments origin="podcast" />
            </q-tab-pane>

        </q-tabs>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import BasicData from 'components/admin/podcasts/BasicData'
import Audios from 'components/admin/podcasts/Audios'
import ConfigureAndPublish from 'components/admin/podcasts/ConfigureAndPublish'
import Comments from 'components/admin/Comments'

export default {
    i18nOptions: { namespaces: ['custom', 'common', 'podcasts', 'admin'] },

    data() {
        return {
            id: '',
            tab: 'basic-data',
            permissions: {
                podcasts_manage: false
            }
        }
    },

    components: {
        'basic-data': BasicData,
        'audios': Audios,
        'configure-and-publish': ConfigureAndPublish,
        'comments': Comments
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
            user_client_module_items: 'common/user_client_module_items',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        showTab() {
            if (this.id != 0) return true
            else return false
        },

        title_podcasts(){
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
				if (obj) {
					return obj.title_podcasts === '' ? 'podcasts' : obj.title_podcasts
				}
			}
        },

        useCommentsPodcast() {
            let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            if(obj) return  obj.use_comments_podcast
            else return true
        }
    },

    methods: {
        changeTab() {
            this.tab = 'basic-data'
        },

        checkPermissions() {
            const client = this.user_client_module_items.find((obj) => { return obj.id === this.id_user_client_selected })
            if (client) {
                for (const [key, value] of Object.entries(this.permissions)) {
                    let obj = client.module_items.find(obj => obj.slug === key)
                    if (obj) {
                        this.permissions[key] = obj.permission
                    }
                }
            } else return
        },
    },

    watch: {
        '$route': function (refreshPage) {
            this.id = this.$route.params.id
        }
    },

    created() {
        this.id = this.$route.params.id
        this.checkPermissions()
    }
}
</script>

<style>

</style>
